import React from 'react';
import styled from 'styled-components';

const HeaderRightMenuWrapper = styled.div`
  max-width: 100%;
  min-width: 0;
  display: flex;
  justify-content: end;
  height: ${props => props.theme.layoutHeaderContentHeight}px;
  align-items: center;
`;

export interface IHeaderRightMenuProps
  extends React.HTMLAttributes<HTMLDivElement> {}

export function HeaderRightMenu(props: IHeaderRightMenuProps) {
  return <HeaderRightMenuWrapper {...props} />;
}
